import { Controller } from "@hotwired/stimulus";
import { initializeTooltips } from "../../../../../../scripts/tooltips";
import { disableElementAndAddSpinner } from "../../../../../../scripts/jobCompletion";

export default class PoiPagedListController extends Controller {

    static targets = [
        "pageLink"
    ];

    readonly pageLinkTargets!: HTMLAnchorElement[];

    connect() {
        initializeTooltips($(this.element));

        this.pageLinkTargets.forEach(pageLink => {             
            pageLink.addEventListener("click", _ => {
                disableElementAndAddSpinner($(pageLink));
            });
        });
    }
}